/**
 * @author NamNguyen
 * @desc Interceptor handle for all request.
 */
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UrlFactory } from "./url-factory";

@Injectable({
	providedIn: "root"
})
export class ApiPrefixInterceptor implements HttpInterceptor {
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// Ignore append serverUrl if url contain http/https.
		if (!/^(http|https):/i.test(request.url)) {
			request = request.clone({
				url: UrlFactory.generateUrl() + request.url
			});
		}
		return next.handle(request);
	}
}
